module.exports = __webpack_public_path__ + "static/img/park-1.256fe74a.png";